import {createArrayIntentType} from '../intent';
import type {Intent} from '../intent';
import type {ThemeMetadata} from './types';

// Keep the theme boundary intact until the view evaluates its theme policy.
export const themeIntent = createArrayIntentType(
  'theme',
  (decorate) => (intents: Intent<unknown>[], metadata: ThemeMetadata) => {
    const theme = {intents, metadata};
    Object.defineProperty(theme, 'metadata', {
      value: metadata,
      enumerable: false,
      writable: false,
    });
    return decorate(theme);
  },
);

export const forceApplyThemesIntent = createArrayIntentType(
  'forceApplyThemes',
  (decorate) => (intents: Intent<unknown>[]) => decorate({intents}),
);
